import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { updateContactData } from '../../../../store/reducers/clientContacts';
import STSComponent from "../../../STSComponent/STSComponent";
import { clientConstants } from '../../constants';
import ModalWrapper from '../ModalWrapper';
import ClientContactRow from './components/ClientContactRow';

class ClientContacts extends STSComponent {
  render () {
    const {
      modal,
      users,
      page,
      clientContacts,
      contactsTrackData,
      updateContactData,
      newItem,
      editItem
    } = this.props
    const contactsValues = newItem ? clientConstants.emptyList.clientContact : clientContacts
    return (
      <div className="user-body">
        {modal
          ? null
          : <ModalWrapper
            users={users}
            data={clientContacts}
          />}
        <div className="w-100">
          {contactsValues
            ? <div className="d-flex flex-row row-border-bt title-p">
              <div className="client-contact-col title">Contact Name</div>
              <div className="client-contact-col title">Email</div>
              <div className="client-contact-col title">Phone</div>
              <div className="client-contact-col with-cb title">Primary User</div>
            </div>
            : null}
          <ClientContactRow
            contacts={contactsValues}
            page={page}
            trackData={contactsTrackData}
            updateData={updateContactData}
            field="clientContacts"
            modal={modal}
            editItem={editItem}
          />
        </div>
      </div>
    )
  }

  static propTypes = {
    users: PropTypes.bool,
    page: PropTypes.string,
    contactsTrackData: PropTypes.object,
    updateContactData: PropTypes.func,
    modal: PropTypes.bool,
    clientContacts: PropTypes.array,
    newItem: PropTypes.bool,
    editItem: PropTypes.object
  }
}

export default connect(state => ({
  clientContacts: state.clientContacts.renderData.clientContacts,
  contactsTrackData: state.clientContacts.formDataValue.clientContacts
}), {
  updateContactData
})(ClientContacts)



// WEBPACK FOOTER //
// ./src/components/ClientContacts/components/ClientContacts/ClientContacts.js